import { Controller } from "@hotwired/stimulus"

const SLIDE_DURATION = 2600
const TICK = 60

export default class extends Controller {
  static targets = ["slides", "name", "progress", "empty"]

  connect() {
    this.items = []
    this.currentIndex = 0
    this.elapsed = 0
    this.paused = false
    this.fetchNewArrivals()
  }

  disconnect() {
    clearInterval(this.timer)
  }

  async fetchNewArrivals() {
    try {
      const response = await fetch("/api/v1/parfums?sort=newest&limit=5")
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`)
      const data = await response.json()
      this.items = data.filter((p) => p.image_url)

      if (this.items.length === 0) {
        if (this.hasEmptyTarget) this.emptyTarget.hidden = false
        return
      }

      this.renderSlides()
      this.renderProgress()
      this.goTo(0)
      this.startTimer()
    } catch (error) {
      console.error("Erreur lors du chargement des nouveautés:", error)
      if (this.hasEmptyTarget) this.emptyTarget.hidden = false
    }
  }

  renderSlides() {
    this.slidesTarget.innerHTML = this.items
      .map(
        (item, i) => `
      <a href="/vitrine/parfums/${item.slug || item.id}" class="hero-slider-slide" data-index="${i}">
        <img src="${item.image_url}" alt="${item.name}">
      </a>
    `
      )
      .join("")
  }

  renderProgress() {
    this.progressTarget.innerHTML = this.items
      .map(
        (item, i) => `
      <span class="hero-slider-progress-track" data-action="click->hero-slider#jump" data-index="${i}">
        <span class="hero-slider-progress-fill" data-index="${i}"></span>
      </span>
    `
      )
      .join("")
  }

  startTimer() {
    this.timer = setInterval(() => {
      if (this.paused || this.items.length === 0) return
      this.elapsed += TICK
      if (this.elapsed >= SLIDE_DURATION) {
        this.goTo((this.currentIndex + 1) % this.items.length)
      } else {
        this.updateProgressFill()
      }
    }, TICK)
  }

  jump(event) {
    const index = parseInt(event.currentTarget.dataset.index, 10)
    if (!isNaN(index)) this.goTo(index)
  }

  goTo(index) {
    this.currentIndex = index
    this.elapsed = 0

    this.slidesTarget.querySelectorAll(".hero-slider-slide").forEach((el) => {
      el.classList.toggle("is-active", parseInt(el.dataset.index, 10) === index)
    })

    const current = this.items[index]
    if (current && this.hasNameTarget) this.nameTarget.textContent = current.name

    this.updateProgressFill()
  }

  updateProgressFill() {
    const progress = Math.min(100, (this.elapsed / SLIDE_DURATION) * 100)
    this.progressTarget.querySelectorAll(".hero-slider-progress-fill").forEach((el) => {
      const i = parseInt(el.dataset.index, 10)
      el.style.width = this.fillWidthFor(i, progress)
    })
  }

  // Les diapositives déjà passées sont pleines, celle en cours suit la
  // progression, les suivantes restent vides.
  fillWidthFor(index, progress) {
    if (index < this.currentIndex) return "100%"
    if (index === this.currentIndex) return `${progress}%`
    return "0%"
  }

  pause() {
    // Sur tactile, un tap déclenche un "mouseenter" synthétique sans "mouseleave"
    // correspondant : on ignore la pause quand l'appareil n'a pas de vrai hover,
    // sinon le slider reste bloqué en pause dès la première interaction mobile.
    if (window.matchMedia("(hover: hover)").matches) this.paused = true
  }

  resume() {
    this.paused = false
  }
}
